import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__radix_ui_react_visually_hidden_82455f0f__ from "@radix-ui/react-visually-hidden";
function VisuallyHidden(props) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        style: {
            position: 'relative'
        },
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__radix_ui_react_visually_hidden_82455f0f__.Root, {
            ...props
        })
    });
}
export { VisuallyHidden as default };

//# sourceMappingURL=VisuallyHidden.js.map